import Root from '../views/Root'

export default {
  path: '/',
  name: 'root',
  component: Root
}
